const MAX_ROWS = 6;

export default function Breakdown({title, rows, total}) {
    const shown = rows.slice(0, MAX_ROWS);
    const rest = rows.slice(MAX_ROWS).reduce((s, r) => s + r.count, 0);
    if (rest) shown.push({label: `${rows.length - MAX_ROWS} more`, count: rest, other: true});
    const max = Math.max(...shown.map(r => r.count));

    return (
        <section className="card breakdown">
            <h3>{title}</h3>
            <ul>
                {shown.map(r => (
                    <li key={r.label} className={r.other || r.label === 'Unknown' ? 'other' : undefined}>
                        <div className="bar-label">
                            <span>{r.label}</span>
                            <span className="muted">{r.count} · {Math.round((r.count / total) * 100)}%</span>
                        </div>
                        <div className="bar"><span style={{width: `${(r.count / max) * 100}%`}} /></div>
                    </li>
                ))}
            </ul>
        </section>
    );
}
